/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetUsersPreferencesWaterCharacteristicsOptions, GetUsersPreferencesWaterCharacteristicsResponses } from '../types/GetUsersPreferencesWaterCharacteristics'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /users/preferences/water-characteristics/}
 */
export function getUsersPreferencesWaterCharacteristics<ThrowOnError extends boolean = true>(options: Options<GetUsersPreferencesWaterCharacteristicsOptions, ThrowOnError> = {}): Unwrappable<RequestResult<GetUsersPreferencesWaterCharacteristicsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/users/preferences/water-characteristics/', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetUsersPreferencesWaterCharacteristicsResponses, ThrowOnError>>)
}
